// import { Modal } from "antd";
import request from "project-config/services/request/request";
import {
  ModalStyle,
  RechargeForm,
  RechargeVoucherTitle,
  RechargeVoucherWrapper,
} from "./atom";
import { Form } from "@renderbus/ui";
import { Input, Modal, ModalType } from "task-eva-ui";
import useForm from "antd/es/form/hooks/useForm";
import { useClientTopUpStore } from "../../store";
import { useEffect, useState } from "react";
import { useToastStore } from "@/store/toast-store";
import { useTranslation } from "react-i18next";
import { initVerifyRechargeInfo } from "../../constants";

const RechargeVoucherModal: React.FC = () => {
  const { t } = useTranslation("topup");
  const [form] = useForm();
  const {
    inputCode,
    setInputCode,
    showCouponCodeModal,
    setShowCouponCodeModal,
    setVerifyRechargeInfo,
    rechargeAmount,
  } = useClientTopUpStore();
  const [loading, setLoading] = useState(false);
  const onInput = (val: any) => {
    setInputCode(val);
    form.setFieldValue("inputCode", val);
  };
  const { showGlobalToast } = useToastStore();

  const verifyCode = () => {
    setLoading(true);
    form
      .validateFields()
      .then(async () => {
        showGlobalToast({
          type: "success",
          content: "渲染券兑换码可用，充值完成后渲染券将立即到账",
        });
        const couponNO = form.getFieldValue("inputCode");
        const apiName = "/api/rendering/pay/recharge/verifyRechargeCode";
        const { code, data } = await request.post(apiName, {
          couponNO,
          amount: Number(rechargeAmount),
        });
        setLoading(false);
        if (code === 200) {
          setVerifyRechargeInfo(data);
          showGlobalToast({
            type: "success",
            content: "渲染券兑换码可用，充值完成后渲染券将立即到账",
          });
        } else {
          setVerifyRechargeInfo(initVerifyRechargeInfo);
          showGlobalToast({
            type: "error",
            content: t(`renderbus_coupon_code_tips_${code}`),
          });
        }
        setShowCouponCodeModal(false);
        form.resetFields(["inputCode"]);
        setInputCode("");
      })
      .catch((e) => {
        setLoading(false);
      });
  };
  const handleClose = () => {
    setShowCouponCodeModal(false);
    form.resetFields(["inputCode"]);
    setInputCode("");
  };

  useEffect(() => {
    if (showCouponCodeModal) {
      form.setFieldValue("inputCode", inputCode || "");
    }
  }, [showCouponCodeModal, inputCode, form]);

  return (
    <RechargeVoucherWrapper>
      <RechargeVoucherTitle onClick={() => setShowCouponCodeModal(true)}>
        充值兑换码
      </RechargeVoucherTitle>
      <Modal
        type={ModalType.Confirm}
        open={showCouponCodeModal}
        title="充值兑换码"
        submitting={loading}
        onClose={handleClose}
        onOk={verifyCode}
        confirmText="确认"
        children={
          <RechargeForm form={form}>
            <div className="title">兑换码</div>
            <Form.Item
              name="inputCode"
              rules={[
                { required: true, message: "必填" },
                {
                  pattern: new RegExp(/^[0-9a-zA-Z]{4,18}$/, "g"),
                  message: "请输入正确格式的渲染券兑换码",
                },
              ]}
            >
              <div className="client-coupon-code-input">
                <Input
                  value={inputCode}
                  background="#212327"
                  onInput={(e) => onInput?.(e.currentTarget.value)}
                  placeholder={"请输入兑换码"}
                />
              </div>
            </Form.Item>
          </RechargeForm>
        }
      />
      <ModalStyle />
    </RechargeVoucherWrapper>
  );
};
export default RechargeVoucherModal;
